module.exports = __webpack_public_path__ + "img/V-L-5-unload-standup-shadow.7ea87c87.png";